import React, { useState, useEffect } from "react";
import { Col, Button, Form, Row } from "react-bootstrap";
import { Formik } from "formik";
import classes from "../../WebsiteManagement/websiteManagement.module.css";
import MealTypeList from "./addMealList";


const AddMealType = (props) => {

  return (
    <div className={classes.Box}>
      <Formik
        initialValues={{}}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          const newData = {
            mealType: values.mealType,
            numberOfAdults: values.numberOfAduts,
            numberOfChildren: values.numberOfChildren,
          };
          console.log(newData);
          const token = localStorage.getItem('token');
          const authHeader = `Bearer ${token}`
          const res = await fetch("https://api.zupptravel.com/api/v1/hotel/addMealType", {
            method: "post",
            headers: {
              "Content-Type": "application/json",
              'Authorization': authHeader
            },
            body: JSON.stringify(newData),
          });

          const json = await res.json();

          if (json.success) {
            alert("Added Meal Type!");
            // props.click();
            // window.location.reload();
          } else {
            alert("Error! Please try again later");
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          resetForm,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form onSubmit={handleSubmit}>
            {/* <Form.Group controlId="formBasicVendor" as={Row}>
              <Form.Label column sm="3">
                Vendor ID:
              </Form.Label>
              <Col sm="9">
                <SingleSelect
                  type="3"
                  list={vendorList}
                  change={(select) => updateVendorId(select)}
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="formBasicVendor" as={Row}>
              <Form.Label column sm="3">
                Accommodation ID:
              </Form.Label>
              <Col sm="9">
                <SingleSelect
                  type="4"
                  list={accList}
                  change={(select) => updateaccomodationId(select)}
                />
              </Col>
            </Form.Group> */}
            <Form.Group controlId="formBasic" as={Row}>
              <Form.Label column sm="3">
                Meal Type:
              </Form.Label>
              <Col sm="9">
                <Form.Control
                  type="text"
                  placeholder="Enter Meal Type"
                  name="mealType"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.mealType}
                  required
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="formBasicNumberOfAduts" as={Row}>
              <Form.Label column sm="3">
                Number of Adults:
              </Form.Label>
              <Col sm="9">
                <Form.Control
                  type="number"
                  placeholder="Enter Number of Adults"
                  name="numberOfAduts"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.numberOfAduts}
                  required
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="formBasicNumberOfChildren" as={Row}>
              <Form.Label column sm="3">
                Number of Children:
              </Form.Label>
              <Col sm="9">
                <Form.Control
                  type="number"
                  placeholder="Enter Number of Children"
                  name="numberOfChildren"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.numberOfChildren}
                  required
                />
              </Col>
            </Form.Group>
            <center>
              <Button type="submit" variant="success">
                Save Meal
              </Button>
            </center>
          </Form>
        )}
      </Formik>
      <hr />
      <MealTypeList />
    </div>
  );
};
export default AddMealType;
